package nl.appstuff.padelchecker.site.directory

data class DirectoryClub(
    val id: Long,
    val slug: String,
    val name: String,
    val citySlug: String,
    val cityName: String,
    val provinceSlug: String,
    val provinceName: String,
    val latitude: Double,
    val longitude: Double,
    val address: String,
    val postalCode: String?,
    val courtCount: Int?,
    val platforms: List<String>,
    val websiteUrl: String?,
)

data class DirectoryCity(
    val slug: String,
    val name: String,
    val provinceSlug: String,
    val provinceName: String,
    val clubCount: Int,
)

data class DirectoryProvince(
    val slug: String,
    val name: String,
    val clubCount: Int,
)

object Directory {
    val clubs: List<DirectoryClub> get() = GeneratedDirectory.clubs
    val cities: List<DirectoryCity> get() = GeneratedDirectory.cities
    val provinces: List<DirectoryProvince> get() = GeneratedDirectory.provinces

    fun club(citySlug: String, slug: String): DirectoryClub? =
        clubs.firstOrNull { it.citySlug == citySlug && it.slug == slug }

    fun city(slug: String): DirectoryCity? = cities.firstOrNull { it.slug == slug }
    fun province(slug: String): DirectoryProvince? = provinces.firstOrNull { it.slug == slug }

    fun clubsInCity(citySlug: String): List<DirectoryClub> = clubs.filter { it.citySlug == citySlug }
    fun clubsInProvince(provinceSlug: String): List<DirectoryClub> =
        clubs.filter { it.provinceSlug == provinceSlug }

    fun citiesInProvince(provinceSlug: String): List<DirectoryCity> =
        cities.filter { it.provinceSlug == provinceSlug }
}
